"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _Login = require("../../../../Content/Login");
var _Button = require("../../../../UI/Button");
var _Header = require("../Header.labels");
var _Header2 = _interopRequireDefault(require("../Header.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LoginButton = props => {
  const {
    isMobileView,
    user
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  const styles = (0, _Header2.default)(isMobileView, !Boolean(user?.userId));
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  if (user?.userId) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Header__toolbar__login-button'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      onClick: () => {
        setIsOpen(true);
      },
      id: "ccHeaderLoginButton",
      view: "link",
      color: "primary",
      category: "upperToolbar",
      label: "login",
      optionalData: {
        objectAdditionalInformation: {
          context: 'Login'
        }
      },
      children: getLabel('login')
    }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Login.Login, {
      onClose: handleClose
    })]
  });
};
exports.LoginButton = LoginButton;